import { useMutation } from 'react-query'

import { request } from '../../global/api/legacyApi'
import { HTTPMethod } from '../utils/api.types'
import type { APIResponse } from '../utils/api.types'

type CancelGuestRequestRequest = {
  live_id: string
  live_speaker_id: string
  presenter_token: string
  cancel_method: 'expire' | 'delete'
}

type CancelGuestRequestResponse = APIResponse

type CancelGuestRequestData = {
  sessionId: CancelGuestRequestRequest['live_id']
  speakerId: CancelGuestRequestRequest['live_speaker_id']
  presenterToken: CancelGuestRequestRequest['presenter_token']
  cancelMethod?: CancelGuestRequestRequest['cancel_method']
}

type CancelGuestRequestMutationRequest = CancelGuestRequestData

function cancelGuestRequest(data: CancelGuestRequestData) {
  return request<CancelGuestRequestResponse>({
    url: '/api/2/live/speaker/cancel-guest-request',
    method: HTTPMethod.POST,
    data: {
      live_id: data.sessionId,
      live_speaker_id: data.speakerId,
      presenter_token: data.presenterToken,
      cancel_method: data.cancelMethod || 'delete',
    } satisfies CancelGuestRequestRequest,
  })
}

function useCancelGuestRequestMutation() {
  return useMutation<void, unknown, CancelGuestRequestMutationRequest>(
    async (data) => {
      await cancelGuestRequest(data)
    }
  )
}

export { cancelGuestRequest, useCancelGuestRequestMutation }
